'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/subscription/Subscription.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var SubscriptionIcon = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M10.0782 2.16222C11.101 1.01146 12.899 1.01146 13.9218 2.16222L15.6328 4.08724C16.0011 4.50155 16.4933 4.78576 17.0362 4.89752L19.5589 5.41677C21.0669 5.72717 21.9659 7.28429 21.4807 8.74545L20.6691 11.1897C20.4944 11.7158 20.4944 12.2842 20.6691 12.8103L21.4807 15.2545C21.9659 16.7157 21.0668 18.2728 19.5589 18.5832L17.0362 19.1025C16.4933 19.2142 16.0011 19.4984 15.6328 19.9128L13.9218 21.8378C12.899 22.9885 11.101 22.9885 10.0782 21.8378L8.36719 19.9128C7.99895 19.4984 7.50668 19.2142 6.96376 19.1025L4.44114 18.5832C2.93315 18.2728 2.03415 16.7157 2.51933 15.2545L3.33095 12.8103C3.50563 12.2842 3.50563 11.7158 3.33095 11.1897L2.51933 8.74545C2.03415 7.28429 2.93315 5.72717 4.44114 5.41677L6.96376 4.89752C7.50668 4.78576 7.99895 4.50155 8.36719 4.08724L10.0782 2.16222Z",
            fill: "#FF2C79",
            stroke: "#E4E4E7",
            strokeWidth: "1.5"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.416 7.72265C12.3233 7.58355 12.1672 7.5 12 7.5C11.8328 7.5 11.6767 7.58355 11.584 7.72265L9.82883 10.3554L7.22362 9.05279C7.05217 8.96706 6.8468 8.9869 6.69493 9.10386C6.54306 9.22083 6.47143 9.41432 6.51053 9.60198L7.76053 15.602C7.80883 15.8338 8.01318 16 8.25002 16H15.75C15.9869 16 16.1912 15.8338 16.2395 15.602L17.4895 9.60198C17.5286 9.41432 17.457 9.22083 17.3051 9.10386C17.1532 8.9869 16.9479 8.96706 16.7764 9.05279L14.1712 10.3554L12.416 7.72265Z",
            fill: "#E4E4E7"
          }
        )
      ]
    })
  );
};

export {
  SubscriptionIcon
};
//# sourceMappingURL=chunk-M4AEAEEW.mjs.map